import { Controller } from "@hotwired/stimulus"

// Disables Trix file attachments inside the support widget.
// Listens for Trix's `trix-file-accept` event and cancels it,
// preventing pasted/dropped images or files from being attached.
export default class extends Controller {
  preventAttachments(event) {
    event.preventDefault()
  }
}
